import i18n from 'i18next';
import config from 'i18n-config';
import { initReactI18next } from 'react-i18next';

export function initI18n(lang = 'ru') {
  i18n.use(initReactI18next).init(config(lang));
}
